import { STAGES_IDS } from '@app/constants';
import { LeaderParticipant } from '@app/interface/valoration-last-assessment.interface';

export function generateLeaderParticipantsMock(
  count: number,
  startId: number = 1,
  statusId: STAGES_IDS = STAGES_IDS.Pending
): LeaderParticipant[] {
  const persons: LeaderParticipant[] = [];

  for (let i = 0; i < count; i++) {
    const id = startId + i;
    const firstName = `name_${id}`;
    const lastName = `lastname_${id}`;
    const email = `${firstName}.${lastName}@pragma.com.co`;
    const image = `images/users_avatar/${firstName}_${lastName}@pragma_com_co_REDONDA.png`;

    persons.push({
      person_id: id,
      person_name: `${capitalize(firstName)} ${capitalize(lastName)}`,
      image_url: image,
      email,
      status_id: statusId,
    });
  }

  return persons;
}

function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
